var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    height: 14,
    width: 14,
    id: "Notebook--Streamline-Flex.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Notebook Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notebook--pencil-content-write-notebook-book-edit-composition-creation"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fill: "#b6c0f3",
    fillRule: "evenodd",
    d: "M3.55523 12.6585c-0.95542 -0.13 -1.7072 -0.9079 -1.7988 -1.8678 -0.26378 -2.76411 -0.26378 -5.43303 0 -8.19718 0.0916 -0.95986 0.84338 -1.737806 1.7988 -1.867722 2.21408 -0.301064 4.30068 -0.301064 6.51477 0 0.9554 0.129916 1.7072 0.907862 1.7988 1.867722 0.1014 1.06291 0.1639 2.11173 0.1873 3.15731 -0.8122 -0.01865 -1.6377 0.27788 -2.26437 0.98889L6.92576 9.99165c-0.19891 0.22565 -0.33628 0.49885 -0.39885 0.79315l-0.39263 1.8466c-0.01737 0.0817 -0.02974 0.1624 -0.03752 0.2417 -0.83789 -0.0259 -1.68006 -0.0975 -2.54153 -0.2146Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    stroke: "#313b6b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.0434 5.29577c-0.0297 -0.89497 -0.0879 -1.79346 -0.1746 -2.70225 -0.0916 -0.95986 -0.8434 -1.737806 -1.7988 -1.867722 -2.21409 -0.301064 -4.30069 -0.301064 -6.51477 0 -0.95542 0.129916 -1.7072 0.907862 -1.7988 1.867722 -0.26378 2.76415 -0.26378 5.43307 0 8.19718 0.0916 0.9599 0.84338 1.7378 1.7988 1.8678 0.66384 0.0902 1.31622 0.1534 1.96402 0.1896",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 5627"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1270",
    stroke: "#313b6b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.5 3.8009c0.69313 -0.29003 1.30687 -0.29003 2 0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1272",
    stroke: "#313b6b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.5 9.8009c0.69313 -0.29003 1.30687 -0.29003 2 0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1273",
    stroke: "#313b6b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.5 6.72143c0.69313 -0.29003 1.30687 -0.29003 2 0",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "#ffffff",
    d: "M11.1045 7.89686 8.23856 11.1488l-0.39263 1.8466c-0.06318 0.2972 0.24655 0.5783 0.53661 0.4871l1.83766 -0.5777 2.9603 -3.11485c0.4916 -0.51734 0.4058 -1.38262 -0.1893 -1.90902 -0.5812 -0.51406 -1.4259 -0.50693 -1.8867 0.01593Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#313b6b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.1045 7.89686 8.23856 11.1488l-0.39263 1.8466c-0.06318 0.2972 0.24655 0.5783 0.53661 0.4871l1.83766 -0.5777 2.9603 -3.11485c0.4916 -0.51734 0.4058 -1.38263 -0.1893 -1.90902 -0.5812 -0.51406 -1.4259 -0.50693 -1.8867 0.01593Z",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook);
export default __webpack_public_path__ + "static/media/Notebook.245db4ef57510f632311ee0cd5552bf9.svg";
export { ForwardRef as ReactComponent };